import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { MorayEastInstructionsComponent } from '../grids/moray-east-instructions/moray-east-instructions.component';
import { Router } from '@angular/router';
import { DateFormatHelperService } from 'src/app/core/services/date-format-helper.service';
import { MorayEastService } from 'src/app/core/services/moray-east.service';
import { AdHocInstructionsService } from 'src/app/core/services/ad-hoc-instructions.service';
import { AdHocInstructionsGridDTO } from 'src/app/core/Dtos/ad-hoc/instructions-grid-dto';
import { MorayEastInstructionsGridDTO } from 'src/app/core/Dtos/moray-east/instructions-grid-dto';
import { Assets } from 'src/app/core/Dtos/assets-enum';
import { BaseComponent } from '../../base-component';
import { AlertsService } from 'src/app/core/services/alerts.service';
import { TraderInstructionArgs } from '../../dashboards-viewer/trader-instruction-view-args';
import { OktaService } from '@engie-group/ngx-gem-spaas';

@Component({
    selector: 'app-moray-east-dashboard',
    templateUrl: './moray-east-dashboard.component.html',
    styleUrl: './moray-east-dashboard.component.scss',
    standalone: false
})
export class MorayEastDashboardComponent extends BaseComponent {
  @Output() 
  public OnViewInstruction : EventEmitter<TraderInstructionArgs> = new EventEmitter<TraderInstructionArgs>();

  public SearchCurrentAndFuture: string = "ShowActiveAndFutrure";
  public SearchDateFrom: Date = new Date();
  public SearchDateTo: Date = new Date();

  public MorayEastIntructionsData: MorayEastInstructionsGridDTO[] = [];
  public MorayEastAdHocData: AdHocInstructionsGridDTO[] = [];
  public MorayEastLastRefresh: string = "";

  @ViewChild(MorayEastInstructionsComponent)
  _instructionsComponent: MorayEastInstructionsComponent | undefined;

  constructor(
    dateFormatHelper: DateFormatHelperService,
    oktaService: OktaService,
    alertService: AlertsService,
    private _router: Router,
    private _morayEastService: MorayEastService,
    private _adHocService: AdHocInstructionsService) {
    super(oktaService, alertService, dateFormatHelper)
      // Load Moray East Instructions
    this.GetInstructions();
    this.SearchDateFrom.setMonth(this.SearchDateFrom.getMonth() - 1);
  }

  public GetInstructions() {
    if (this.SearchCurrentAndFuture == "ShowActiveAndFutrure") {
      this._morayEastService.GetActiveAndFutureInstructions().subscribe(
        resp => {
          this.MorayEastIntructionsData = resp;
          this.MorayEastLastRefresh = this.DateFormatHelper.GetDisplayDate(new Date());
        });
      this._adHocService.GetActiveAndFutureInstructions(Assets.MorayEast).subscribe(
        resp => {
          this.MorayEastAdHocData = resp;
        }
      );
    }
    else {
      this._morayEastService.GetInstructionsByDateRange(this.SearchDateFrom, this.SearchDateTo).subscribe(
        resp => {
          this.MorayEastIntructionsData = resp;
          this.MorayEastLastRefresh = this.DateFormatHelper.GetDisplayDate(new Date());
        });
      this._adHocService.GetInstructionsByDateRange(Assets.MorayEast, this.SearchDateFrom, this.SearchDateTo).subscribe(
        resp => {
          this.MorayEastAdHocData = resp;
        }
      );
    }
  }

  public SetDateTo(target: any) {
    this.SearchDateTo = target.valueAsDate;
  }
  public SetDateFrom(target: any) {
    this.SearchDateFrom = target.valueAsDate;
  }

  public AddNewInstruction() {
    this._router.navigate(["/moweo-new"]);
  }

  public AddNewAdHocInstruction() {
    this._router.navigate(["moweo/adhoc-new"]);
  }

  public ViewInstruction(instructionId: string | number, isAdHoc:boolean) {
    this.OnViewInstruction?.next(new TraderInstructionArgs(Assets.MorayEast, instructionId, isAdHoc));
  }
}